module.exports = __webpack_public_path__ + "img/discount-ticket.8c9fd0fe.webp";